import React from "react";

const ProjectCardSkeleton = () => {
    return (
        <article className="overflow-hidden rounded-2xl bg-white shadow-md dark:bg-slate-800">
            {/* Image area */}
            <div className="relative">
                <div className="aspect-[4/3] w-full skeleton-shimmer rounded-none" />

                {/* Category badge placeholders */}
                <div className="absolute left-0 top-0 flex gap-2 p-5">
                    <div className="h-6 w-14 rounded-full bg-white/20 backdrop-blur-sm" />
                    <div className="h-6 w-18 rounded-full bg-white/20 backdrop-blur-sm" />
                </div>

                {/* Title placeholder on image */}
                <div className="absolute bottom-0 left-0 right-0 p-6 space-y-2">
                    <div className="h-6 w-3/4 rounded bg-white/20" />
                    <div className="h-6 w-1/2 rounded bg-white/20" />
                </div>
            </div>

            {/* Content area */}
            <div className="p-6 lg:p-8">
                {/* Stats row */}
                <div className="mb-5 flex items-center divide-x divide-slate-200 dark:divide-slate-700">
                    <div className="flex-1 pr-4 text-center space-y-2">
                        <div className="mx-auto h-8 w-20 rounded skeleton-shimmer" />
                        <div className="mx-auto h-3 w-24 rounded skeleton-shimmer" />
                    </div>
                    <div className="flex-1 pl-4 text-center space-y-2">
                        <div className="mx-auto h-8 w-20 rounded skeleton-shimmer" />
                        <div className="mx-auto h-3 w-24 rounded skeleton-shimmer" />
                    </div>
                </div>

                {/* Excerpt lines */}
                <div className="space-y-2">
                    <div className="h-4 w-full rounded skeleton-shimmer" />
                    <div className="h-4 w-full rounded skeleton-shimmer" />
                    <div className="h-4 w-2/3 rounded skeleton-shimmer" />
                </div>

                {/* CTA placeholder */}
                <div className="mt-6 h-4 w-32 rounded skeleton-shimmer" />
            </div>
        </article>
    );
};

export default ProjectCardSkeleton;
